import { render, staticRenderFns } from "./FormWizardValidation.vue?vue&type=template&id=d64bf8c4&"
import script from "./FormWizardValidation.vue?vue&type=script&lang=js&"
export * from "./FormWizardValidation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports